export enum DelegationSettlementProcessStep {
  Invoices = 0,
  Mileages = 1,
  SubsistenceAllowances = 2,
  LumpSums = 3,
  Summary = 4
}
